import React, { useState, useEffect } from "react";
import "./Certificates.css";
import BackButton from "../../GoBack/GoBack";
import { useAuthStudent } from "../../../../context/StudentLoginContext/StudentAuthContext";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { StudentMapMenu } from "../../Map/MapMenu/MapMenu";
import { useGetQuestsList } from "../../../../../hooks/student/quest/useGetQuestsList";

export const StudentAdminCertificate = () => {
  const { student, fetchWithAuthStudent } = useAuthStudent(); // Get student details & token
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [quests, setQuests] = useState([]);
  const { quests: studentQuestsList, getStudentQuests } = useGetQuestsList();
  const { userType } = useOutletContext();
  const [activeTab, setActiveTab] = useState("quest");
  const tabs = [
    { label: "Quest", value: "quest" },
    { label: "Festival", value: "festive" },
  ];
  const filteredQuests = quests?.filter(
    (item) => activeTab.toLowerCase() === item.type && item.status === "1"
  );

  useEffect(() => {
    if (userType === "school-student") {
      const fetchStudentQuests = async () => {
        try {
          setLoading(true);
          await getStudentQuests(activeTab.toLowerCase()); // ✔ dynamic fetch
        } catch (err) {
          console.error("Error fetching student quests list:", err);
        } finally {
          setLoading(false);
        }
      };

      fetchStudentQuests();
    }
  }, [userType, activeTab]);

  useEffect(() => {
    const fetchQuestData = async () => {
      if (!student || !student?.token) {
        return;
      }

      try {
        setLoading(true);
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/quests`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch quests");
        }

        const data = await response.json();
        setQuests(data);
        setLoading(false);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchQuestData();
  }, [apiUrl, student, fetchWithAuthStudent]);
  const navigate = useNavigate();
  return (
    <div className="StudentAdminBody StudentBodyMrgn ">
      <div className="container-fluid">
        <div className="teacher-bodycontent mb-4">
          <section>
            <div className="row mb-4">
              <div className="col-md-12">
                <BackButton />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-1"></div>

              <div className="col-md-10 row justify-content-center">
                <div className="position-relative text-center">
                  {/* Desktop Image */}
                  <img
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/BlueBanner.png"
                    alt="quest"
                    className="img-fluid w-100 d-none d-md-block"
                    style={{ objectFit: "cover", height: "auto" }}
                  />

                  {/* Mobile Image */}
                  <img
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/BlueBannerMobile.png"
                    alt="quest"
                    className="img-fluid w-100 d-block d-md-none"
                    style={{ objectFit: "cover", height: "auto" }}
                  />

                  {/* Centered Text */}
                  <div
                    className="position-absolute top-50 start-50 translate-middle text-white text-center"
                    style={{
                      width: "100%",
                      padding: "0 1rem",
                      maxWidth: "100%",
                    }}
                  >
                    <h6 className="fw-semibold display-6 m-0">Certificates</h6>
                    <p className="fs-5 m-0">Your Journey Through Learning</p>
                  </div>
                </div>
                <SkeletonTheme baseColor="#E0E0E0" highlightColor="#F5F5F5">
                  {loading ? (
                    <div className="row mt-5">
                      {Array.from({ length: 8 }).map((_, index) => (
                        <div
                          key={index}
                          className="col-lg-3 col-md-4 col-sm-6 col-12 text-center mb-4"
                        >
                          <div className="certificate-skeleton-wrapper">
                            <Skeleton
                              circle
                              className="certificate-skeleton-circle"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="row mt-5">
                      {userType === "school-student"
                        ? studentQuestsList?.map((item, index) => (
                            <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-12 text-center mb-4">
                              <div className="position-relative d-inline-block">
                                <Link
                                  to={`/student/admin/certificates/${item?.id}`}
                                >
                                  <img
                                    src={item?.thumbnail_url}
                                    alt={item.label}
                                    className="questthumbnail_url"
                                  />

                                  <img
                                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quest/icon/PlayVideo.png"
                                    alt="play"
                                    className="play-icon-logo"
                                  />
                                </Link>
                              </div>
                            </div>
                          ))
                        : filteredQuests?.map((item, index) => (
                            <div
                              key={index}
                              className="col-lg-3 col-md-4 col-sm-6 col-12 text-center mb-4"
                            >
                              <div className="position-relative d-inline-block">
                                <Link
                                  to={`/student/admin/certificates/${item?.id}`}
                                >
                                  <img
                                    src={item?.thumbnail_url}
                                    alt={item.label}
                                    className="questthumbnail_url"
                                  />

                                  <img
                                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quest/icon/PlayVideo.png"
                                    alt="play"
                                    className="play-icon-logo"
                                  />
                                </Link>
                              </div>
                            </div>
                          ))}
                    </div>
                  )}
                </SkeletonTheme>
              </div>
              <div className="col-md-1"></div>
            </div>
            <div>
              <StudentMapMenu />
              {/* <StudentFooter /> */}
            </div>
          </section>
          <div style={{ position: "absolute" }}>
            {/* Left Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/LeftSideDesign.png"
              alt="left"
              className="position-fixed"
              style={{
                left: 0,
                top: "10vh",
                height: "90vh",
                bottom: "auto",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Right Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/RightSideDesign.png"
              alt="right"
              className="position-fixed"
              style={{
                right: 0,
                top: "20vh",
                height: "70vh",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Page Content */}
          </div>
        </div>
      </div>
    </div>
  );
};
